import { createApp } from "vue";
import "normalize.css";
import "@/assets/style/base.css";
import App from "@/App.vue";
import { pinia } from "@/tools/pinia/index";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import router from "@/router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

const app = createApp(App);

pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(ElementPlus);
app.mount("#app");
